<template>
  <v-hover v-slot="{ hover }">
    <v-row
      no-gutters
      align="center"
      class="py-1 px-1 rounded"
      :class="hover ? 'grey lighten-4' : ''"
      style="cursor: pointer; min-height: 36px;"
      @click="$emit('select')"
    >
      <!-- Cliente -->
      <v-col :cols="show_confronta ? 2 : 3" class="d-flex align-center pr-2">
        <v-icon x-small class="mr-1 flex-shrink-0" color="blue-grey lighten-1">mdi-account</v-icon>
        <span class="text-truncate text-body-2">{{ item.cliente }}</span>
      </v-col>

      <!-- Mini-bar proporzionale -->
      <v-col :cols="show_confronta ? 2 : 3" class="d-flex align-center pr-4">
        <div style="width: 100%;">
          <div
            style="height: 8px; background: #eeeeee; border-radius: 4px; overflow: hidden;"
            :style="{ width: bar_width_pct + '%' }"
          >
            <div
              style="height: 100%; float: left; background: #448AFF;"
              :style="{ width: blu_pct + '%' }"
            ></div>
            <div
              style="height: 100%; float: left; background: #00E676;"
              :style="{ width: verde_pct + '%' }"
            ></div>
          </div>
        </div>
      </v-col>

      <!-- Blu -->
      <v-col :cols="show_confronta ? 1 : 2" class="d-flex justify-end text-caption font-weight-medium pr-2" style="color: #448AFF;">
        {{ fmt(item.value.blu) }}
      </v-col>

      <!-- Verde -->
      <v-col :cols="show_confronta ? 1 : 2" class="d-flex justify-end text-caption font-weight-medium pr-2" style="color: #00C853;">
        {{ fmt(item.value.verde) }}
      </v-col>

      <!-- Totale -->
      <v-col :cols="show_confronta ? 1 : 2" class="d-flex justify-end text-caption font-weight-bold pr-2 grey--text text--darken-2">
        {{ fmt(item.value.totale) }}
      </v-col>

      <template v-if="show_confronta">
        <!-- Blu rif -->
        <v-col cols="1" class="d-flex justify-end text-caption pr-2 indigo--text text--lighten-2">
          {{ fmt(item.value_confronto.blu) }}
        </v-col>

        <!-- Verde rif -->
        <v-col cols="1" class="d-flex justify-end text-caption pr-2 teal--text text--lighten-1">
          {{ fmt(item.value_confronto.verde) }}
        </v-col>

        <!-- Tot rif -->
        <v-col cols="1" class="d-flex justify-end text-caption pr-2 grey--text">
          {{ fmt(item.value_confronto.totale) }}
        </v-col>

        <!-- Variazione assoluta -->
        <v-col cols="1" class="d-flex justify-end text-caption font-weight-medium pr-2" :class="var_class">
          {{ variazione_assoluta }}
        </v-col>

        <!-- Variazione % -->
        <v-col cols="1" class="d-flex justify-end text-caption font-weight-medium pr-1" :class="var_class">
          {{ variazione }} %
        </v-col>
      </template>
    </v-row>
  </v-hover>
</template>

<script>
export default {
  name: "analisi_cliente_element",
  props: {
    item: { type: Object, required: true },
    show_confronta: { type: Boolean, required: true },
    max_totale: { type: Number, default: 1 },
  },
  computed: {
    bar_width_pct() {
      if (!this.max_totale) return 100;
      return (this.item.value.totale / this.max_totale) * 100;
    },
    blu_pct() {
      const tot = this.item.value.totale;
      return tot ? (this.item.value.blu / tot) * 100 : 0;
    },
    verde_pct() {
      const tot = this.item.value.totale;
      return tot ? (this.item.value.verde / tot) * 100 : 0;
    },
    variazione() {
      const totale = this.item.value.totale || 0;
      const totale_confronto = this.item.value_confronto.totale || 0;
      return totale_confronto
        ? (((totale - totale_confronto) / totale_confronto) * 100).toFixed(1)
        : "--";
    },
    variazione_assoluta() {
      const delta = (this.item.value.totale || 0) - (this.item.value_confronto.totale || 0);
      const formatted = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.abs(delta));
      return (delta >= 0 ? "+" : "-") + formatted + " €";
    },
    var_class() {
      if (this.variazione === "--") return "grey--text";
      return parseFloat(this.variazione) >= 0 ? "green--text" : "red--text";
    },
  },
  methods: {
    fmt(val) {
      return new Intl.NumberFormat('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(val || 0) + " €";
    },
  },
};
</script>